import { useEffect, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { X } from "lucide-react"
import { AvatarUpload } from "./avatar-upload"
import { useAuthContext } from "@/contexts/AuthContext"
import { useLocation } from "react-router-dom"

const ProfileReminder = () => {
  const [show, setShow] = useState(false)

  const { isAuthenticated, person, loading } = useAuthContext()
  const { pathname } = useLocation()

  useEffect(() => {
    if (person && person?.urlAvatar && !loading && isAuthenticated) {
      setTimeout(() => {
        setShow(true)
      }, 2000)
    }
  }, [person, loading, isAuthenticated])

  if (
    !loading ||
    person?.urlAvatar?.length ||
    ["/", "/profile"].includes(pathname) ||
    !isAuthenticated
  ) {
    return null
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ x: 200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 200, opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed bottom-4 right-4 w-[90%] sm:w-80 p-4 bg-card border border-border rounded-xl shadow-lg z-50"
        >
          <div className="flex items-start justify-between mb-3">
            <h3 className="text-sm font-semibold text-foreground text-center">
              Sube tu foto de perfil
            </h3>
            <button
              onClick={() => setShow(false)}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>

          <div className="grid grid-rows items-center gap-3">
            <div className="flex-1 text-sm text-muted-foreground text-center">
              Añade una imagen para personalizar tu perfil
            </div>
            <AvatarUpload
              src={person?.urlAvatar}
              name={person?.fullName || person?.name || "Usuario"}
              personId={person?.id}
              type="user.avatar"
              cb={() => setShow(false)}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default ProfileReminder
